rdefine('app/formular/models/ChoiceModel',['backbone'],function(Backbone){
    return Backbone.Ribs.Model.extend({
        initialize:function(options) {
            Backbone.Ribs.Model.prototype.initialize.call(this,options);
            this.on("change",_.bind(function(){
                this.collection.trigger("recalc");
            },this));
        }
    });
});